// MSAL imports
import { EventType, PublicClientApplication } from "@azure/msal-browser";
import { getConfig, loginRequest } from "./azure-ad-b2c";
import { validateAndAcquireIfRequired } from "../api/apiToken";
import { getTenant } from "../multi-tenancy/tenantUtils";
import { getTenantLocalStorage } from "../api/config";

export const msalInstancePCA = (function () {
   let msalInstance, tenant;

   return {
      initialize: async function () {
         msalInstance = new PublicClientApplication(getConfig(getTenantLocalStorage()));

         // Default to using the first account if no account is active on page load
         if (!msalInstance.getActiveAccount() && msalInstance.getAllAccounts().length > 0) {
            // Account selection logic is app dependent. Adjust as needed for different use cases.
            msalInstance.setActiveAccount(msalInstance.getAllAccounts()[0]);
         }

         /**
         * Event handler function which allows users to fire events after the PublicClientApplication object
         * has loaded during redirect flows. This should be invoked on all page loads involved in redirect
         * auth flows.
         */
         msalInstance.handleRedirectPromise()
            .then((tokenResponse) => {
               // AuthenticationResult (i.e., tokenResponse) is supplied here only upon login.
               // If null, assume existing token was picked from storage.
               if (!tokenResponse) {
                  if (msalInstance.getActiveAccount()) {
                     // Token is present, but it may be expired. Ensure token is valid and if expired, reissue.
                     // (async () => await validateAndAcquireIfRequired(loginRequest.scopes))();
                  } else {
                     // No user has signed in, auto-sign if not on logout page.
                     if (window.location.pathname !== '/logout') {
                        msalInstance.loginRedirect(loginRequest);
                     }
                  }
               }
            })
            .catch((error) => {
               console.log('handleRedirectPromise:error', error);
            });

         // Optional - This will update account state if a user signs in from another tab or window
         msalInstance.enableAccountStorageEvents();

         msalInstance.addEventCallback((event) => {
            if (event.eventType === EventType.LOGIN_SUCCESS && event.payload.account) {
               console.log('Logged in!');
               const account = event.payload.account;
               msalInstance.setActiveAccount(account);
            } else if (event.eventType === EventType.LOGOUT_SUCCESS) {
               console.log('Logged out!');
            }
         });
      },
      instanceAccessor: async function () {
         if (!msalInstance) await this.initialize();

         return msalInstance;
      },
      tenantAccessor: async function () {
         if (!tenant) await this.initialize();

         return tenant;
      }
   }
})();

export const getMsalInstance = async () => {
   const msalInstance = await msalInstancePCA.instanceAccessor()
   const activeAccount = await msalInstance.getActiveAccount();
   return { msalInstance, activeAccount }
}